import React from 'react';
import {ueGradientColors, AccentColorProps} from 'epic-ue-theme';

export const FeaturesAnimationIcon = ({accentColor = 'sky'}: AccentColorProps): JSX.Element => {
    const gradient = ueGradientColors[accentColor];
    const {from, to} = gradient;

    return (
        <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.2107 14.3477C23.7902 14.2834 24.3866 14.25 25 14.25C25.6997 14.25 26.3748 14.2806 27.0264 14.3408C27.7138 14.4043 28.3226 13.8986 28.3862 13.2112C28.4497 12.5237 27.9439 11.9149 27.2565 11.8514C26.5245 11.7838 25.7725 11.75 25 11.75C24.2957 11.75 23.6073 11.7883 22.935 11.8629C22.2488 11.939 21.7543 12.557 21.8304 13.2431C21.9066 13.9293 22.5245 14.4238 23.2107 14.3477Z"
                fill="url(#paint0_radial)"
            />
            <path
                d="M18.1205 15.8478C18.738 15.5391 18.9885 14.7883 18.6798 14.1708C18.3712 13.5533 17.6204 13.3029 17.0029 13.6115C15.7631 14.2311 14.6121 14.9859 13.5478 15.8464C13.011 16.2805 12.9277 17.0676 13.3617 17.6044C13.7958 18.1412 14.5829 18.2245 15.1197 17.7904C16.0542 17.0348 17.0541 16.3807 18.1205 15.8478Z"
                fill="url(#paint1_radial)"
            />
            <path
                d="M33.8422 13.6279C33.2212 13.3261 32.4733 13.5849 32.1716 14.2058C31.8698 14.8268 32.1286 15.5747 32.7495 15.8764C33.9315 16.4508 35.0171 17.1764 36.0152 18.0524C36.534 18.5078 37.3238 18.4564 37.7792 17.9375C38.2346 17.4187 38.1831 16.6289 37.6643 16.1735C36.5027 15.154 35.2307 14.3026 33.8422 13.6279Z"
                fill="url(#paint2_radial)"
            />
            <path
                d="M11.394 21.755C11.8017 21.198 11.6807 20.4158 11.1236 20.0081C10.5665 19.6003 9.78438 19.7214 9.37663 20.2784C8.58731 21.3568 7.87366 22.4974 7.23317 23.6761C6.90356 24.2827 7.12809 25.0417 7.73468 25.3713C8.34127 25.7009 9.1002 25.4763 9.42981 24.8698C10.0217 23.7805 10.6763 22.7355 11.394 21.755Z"
                fill="url(#paint3_radial)"
            />
            <path
                d="M41.9291 21.4463C41.5796 20.8509 40.8137 20.6516 40.2183 21.001C39.6229 21.3505 39.4236 22.1164 39.773 22.7118C40.4261 23.8245 41.0247 25.0485 41.5712 26.3841C41.8326 27.0231 42.5625 27.3291 43.2015 27.0676C43.8404 26.8062 44.1464 26.0763 43.885 25.4374C43.2992 24.0059 42.6494 22.6736 41.9291 21.4463Z"
                fill="url(#paint4_radial)"
            />
            <path
                d="M7.20002 29.9694C7.42496 29.3168 7.0782 28.6053 6.42552 28.3804C5.77284 28.1554 5.06138 28.5022 4.83645 29.1549C4.39768 30.428 4.03001 31.709 3.73168 32.9739C3.5732 33.6458 3.98943 34.319 4.66135 34.4774C5.33327 34.6359 6.00644 34.2197 6.16491 33.5478C6.44459 32.362 6.78922 31.1614 7.20002 29.9694Z"
                fill="url(#paint5_radial)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M65.1308 31.533L64.3623 33.2201C64.0761 33.8484 63.3349 34.1257 62.7066 33.8395C62.0784 33.5533 61.801 32.8121 62.0872 32.1838L62.8624 30.4818C62.873 30.4587 62.8842 30.436 62.896 30.4137C60.5425 28.7904 59 26.0753 59 23C59 18.0294 63.0294 14 68 14C72.9706 14 77 18.0294 77 23C77 27.9706 72.9706 32 68 32C66.9968 32 66.0319 31.8359 65.1308 31.533ZM74.5 23C74.5 26.5899 71.5899 29.5 68 29.5C64.4101 29.5 61.5 26.5899 61.5 23C61.5 19.4101 64.4101 16.5 68 16.5C71.5899 16.5 74.5 19.4101 74.5 23Z"
                fill="url(#paint6_radial)"
            />
            <path
                d="M45.9079 31.7019C45.7388 31.0326 45.0591 30.6271 44.3898 30.7962C43.7205 30.9653 43.315 31.645 43.4841 32.3143C43.8124 33.6136 44.109 34.9802 44.376 36.4132C44.5024 37.0918 45.1551 37.5395 45.8338 37.4131C46.5124 37.2866 46.9601 36.634 46.8337 35.9553C46.5581 34.4762 46.2505 33.0577 45.9079 31.7019Z"
                fill="url(#paint7_radial)"
            />
            <path
                d="M62.0366 38.326C62.3228 37.6977 62.0454 36.9565 61.4172 36.6703C60.7889 36.3841 60.0477 36.6614 59.7615 37.2897L58.211 40.6936C57.9249 41.3219 58.2022 42.0632 58.8304 42.3493C59.4587 42.6355 60.2 42.3582 60.4861 41.7299L62.0366 38.326Z"
                fill="url(#paint8_radial)"
            />
            <path
                d="M5.31494 39.053C5.36215 38.3643 4.84209 37.7677 4.15335 37.7205C3.46461 37.6733 2.86801 38.1933 2.82079 38.882C2.77361 39.5703 2.75 40.2415 2.75 40.8904C2.75 41.5808 3.30964 42.1404 4 42.1404C4.69036 42.1404 5.25 41.5808 5.25 40.8904C5.25 40.3018 5.27143 39.6878 5.31494 39.053Z"
                fill="url(#paint9_radial)"
            />
            <path
                d="M47.7929 42.3752C47.7125 41.6895 47.0914 41.1989 46.4058 41.2794C45.7201 41.3598 45.2295 41.9809 45.3099 42.6665C45.4695 44.0265 45.6097 45.4315 45.7318 46.8809C45.7897 47.5688 46.3944 48.0795 47.0823 48.0215C47.7702 47.9636 48.2809 47.3589 48.223 46.671C48.0988 45.197 47.9559 43.7647 47.7929 42.3752Z"
                fill="url(#paint10_radial)"
            />
            <path
                d="M58.1604 46.8358C58.4466 46.2076 58.1693 45.4663 57.541 45.1801C56.9128 44.8939 56.1715 45.1712 55.8853 45.7995L54.3348 49.2034C54.0487 49.8317 54.326 50.573 54.9542 50.8591C55.5825 51.1453 56.3238 50.868 56.6099 50.2397L58.1604 46.8358Z"
                fill="url(#paint11_radial)"
            />
            <path
                d="M48.6391 53.1134C48.6067 52.4238 48.0214 51.8911 47.3318 51.9235C46.6422 51.956 46.1095 52.5413 46.1419 53.2309C46.207 54.6151 46.2595 56.0324 46.3002 57.4822C46.3196 58.1722 46.8948 58.7159 47.5849 58.6965C48.275 58.6771 48.8187 58.102 48.7993 57.4119C48.7581 55.9477 48.7051 54.5146 48.6391 53.1134Z"
                fill="url(#paint12_radial)"
            />
            <path
                d="M54.2842 55.3456C54.5704 54.7174 54.2931 53.9761 53.6648 53.6899C53.0366 53.4037 52.2953 53.6811 52.0091 54.3093L50.4586 57.7132C50.1725 58.3415 50.4498 59.0828 51.078 59.3689C51.7063 59.6551 52.4476 59.3778 52.7337 58.7495L54.2842 55.3456Z"
                fill="url(#paint13_radial)"
            />
            <path
                d="M50.408 63.8554C50.6942 63.2272 50.4169 62.4859 49.7886 62.1997C49.1942 61.929 48.4987 62.1626 48.1831 62.7206C48.0206 62.6449 47.8393 62.6031 47.6481 62.6043C46.9578 62.6084 46.4016 63.1715 46.4057 63.8618C46.41 64.568 46.4121 65.2807 46.4121 66C46.4121 66.6904 46.9717 67.25 47.6621 67.25C48.2758 67.25 48.7862 66.8078 48.892 66.2246C49.2092 66.1184 49.4832 65.8858 49.6328 65.5574L50.408 63.8554Z"
                fill="url(#paint14_radial)"
            />
            <defs>
                <radialGradient
                    id="paint0_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint1_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint2_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint3_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint4_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint5_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint6_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint7_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint8_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint9_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint10_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint11_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint12_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint13_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint14_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(77 67.25) rotate(-180) scale(74.25 102.755)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
            </defs>
        </svg>
    );
};
